export { default as TelegramPostController } from './TelegramPost.controller'
